import styled, { css } from 'styled-components'

import { Box } from '../../../shared_components/UI/Box'

import { Link } from 'react-router-dom'
import { defaultTransition } from '../../../theme'

import { getRgbaValue } from '../../../utils/styling/getRgbaValue'
import { ReactNode, useEffect, useRef, useState } from 'react'
import { useScrollPosition } from '../../../hooks/useScrollPosition'

type PoolButtonProps = {
  isUpcoming?: boolean
  narrowButton?: boolean
  secondary?: boolean
}

export const PoolButton = styled.button<PoolButtonProps>`
  width: ${({ narrowButton }) => (narrowButton ? '120px' : '100%')};
  height: 56px;
  left: 20px;
  top: 324px;
  background: ${({ theme }) => theme.colors.brandPrimary};
  color: black;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
  padding: 0px 32px;

  :hover {
    filter: brightness(0.8);
  }
  :disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  ${({ secondary }) =>
    secondary &&
    css`
      background: ${({ theme }) => theme.colors.brandSecondary};
      color: white;
    `}
`
type ChainLabelContainerProps = {
  maxWidth?: number | null
}

export const ChainLabelContainer = styled(Box)<ChainLabelContainerProps>`
  max-width: ${({ maxWidth }) => maxWidth ?? 178}px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding-left: 24px;
  margin-left: 14px;
  @media screen and (max-width: 1000px) {
    margin-bottom: 16px;
  }
`

export const ChainTitle = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  padding-top: 1px;
  text-transform: uppercase;
  margin-left: 8px;
  color: ${(props) => props.theme.semantics.zap.surface.primary}; ;
`

export const IconAndChainContainer = styled(Box)`
  flex: 1;
  width: 100%;
  align-items: center;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
  }
`

export const ChainIconNoBg = styled.img`
  margin-left: 6px;
  position: absolute;
  left: 0px;
  height: 20px;
  width: 20px;
  border-radius: 250px;
`

export const PoolTitle = styled.h1`
  font-weight: 1000;
  font-size: 72px;
  margin: 0;
  line-height: 1;
  font-family: Space Grotesk;
  letter-spacing: -0.04em;
  text-transform: uppercase;
  font-feature-settings: 'ordn' on, 'dnom' on, 'ss01' on;
  color: ${(props) => props.theme.semantics.zap.surface.primary};
  @media screen and (max-width: 767px) {
    font-size: 40px;
    line-height: 45px;
  }
`

type BoxSubHeadingProps = {
  fullOpacity?: boolean
  isValue?: boolean
}

export const BoxSubHeading = styled.span<BoxSubHeadingProps>`
  color: #f6f8ff;
  font-feature-settings: 'ss01' on;
  -webkit-text-stroke-width: 1;
  -webkit-text-stroke-color: #f6f8ff;
  font-family: 'Space Grotesk';
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  opacity: ${({ fullOpacity }) => (fullOpacity ? 1 : 0.5)};
  ${({ isValue }) =>
    isValue &&
    css`
      color: #f6f8ff;
      text-align: right;
      font-feature-settings: 'ss01' on;
      font-family: 'Space Grotesk';
      font-size: 14px;
      font-style: normal;
      font-weight: 300;
      line-height: normal;
    `}
`

export const PoolTicker = styled.h4`
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 25px;
  text-transform: uppercase;
  color: ${(props) => props.theme.semantics.zap.surface.primary};
`

export const OuterWrapper = styled.div`
  z-index: 10;
  position: relative;
  font-family: 'Space Grotesk';
`

export const TopBanner = styled.div<{ bgImage?: string; top: number }>`
  position: relative;
  pointer-events: none;
  width: 100vw;

  z-index: 0;
  :before {
    content: '';
    position: absolute;
    ${defaultTransition}
    top: -${({ top }) => top}px;
    right: 0;
    bottom: 0;
    left: 0;
    height: 641px;
    background: linear-gradient(
      transparent,
      transparent 50%,
      ${(props) => props.theme.semantics.zap.surface.primary}
    );
    pointer-events: none;
    @media screen and (max-width: 1000px) {
      height: 400px;
    }
  }
  :after {
    position: absolute;
    content: '';
    pointer-events: none;
    ${defaultTransition}
    top: -${({ top }) => top}px;
    width: 100%;
    z-index: -2;
    height: 641px;
    background: url(${({ bgImage }) => bgImage});
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    @media screen and (min-width: 600px) and (max-width: 1000px) {
      background-position: center;
      background-size: cover;
      height: 400px;
    }
    @media screen and (max-width: 600px) {
      background-position: center;
      background-size: cover;
      height: 400px;
    }
  }
`

export const ButtonWrapper = styled.div`
  max-width: 200px;
  @media screen and (max-width: 767px) {
    max-width: 95vw;
    grid-template-rows: 48px 48px !important;
    gap: 16px !important;
    margin-bottom: 32px !important;
    margin-top: 32px !important;
  }
`

export const TabToggleBarDesktop = styled.div`
  display: none;
  @media screen and (min-width: 767px) {
    display: flex;
  }
`

export const TabToggleBarMobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    margin-top: 0px;
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
  }
`

export const PeriodTitleContainer = styled.div`
  margin-left: calc(100% - 519px);
  @media screen and (max-width: 1230px) {
    margin-left: 0;
  }
`

export const PeriodTitle = styled.p<{ period?: string }>`
  font-size: 32px !important;
  line-height: 36px !important;
  text-transform: uppercase;
  margin-top: 8px;
  margin-bottom: 16px !important;
  color: ${({ period, theme }) =>
    period === 'upcoming'
      ? theme.colors.brandPrimary
      : period === 'open'
      ? theme.colors.brandSecondary
      : theme.colors.textPrimary};
`

export const SwapAmountLabel = styled.p`
  font-size: 16px;
  line-height: 18px;
  text-transform: uppercase;
  margin-top: 16px;
  color: ${(props) => props.theme.semantics.zap.surface.primary}; ;
`

export const SwapAmount = styled.p`
  font-size: 32px;
  line-height: 36px;
  margin-top: 8px;
  text-transform: uppercase;
`

export const ExhangeRate = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  opacity: 0.6;
  margin-top: -16px;
  margin-bottom: 16px;
`

export const TokenLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`

export const PoolAddress = styled.span`
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.05em;
  opacity: 0.5;
  margin-top: 8px;
  font-family: Space Grotesk;
`

type SwapBoxContainerProps = {
  mobileSwipeOpen: boolean
  swipeOffset: number
  hasScrolled: boolean
  hasTopBar: boolean
}

export const SwapBoxContainer = styled(Box)<SwapBoxContainerProps>`
  z-index: 100;
  position: fixed;
  ${defaultTransition}
  @media screen and (min-width: 1000px) {
    max-width: 321px;
    top: ${({ hasScrolled, hasTopBar }) =>
      hasScrolled ? 32 : hasTopBar ? 264 : 216}px;
  }
  @media screen and (min-width: 1000px) and (max-width: 1400px) {
    left: calc((100vw - 32px - 340px));
  }
  @media screen and (min-width: 1400px) {
    left: calc((100vw - 1400px) / 2 + 1060px);
  }

  @supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background-color: rgba(0, 0, 0, 0.8);
  }
`

type SwapBoxProps = {
  mobileSwipeOpen: boolean
  swipeOffset: number
  hasScrolled: boolean
}

export const SwapBox = styled(Box)<SwapBoxProps>`
  width: 340px;
  height: 100%;
  min-height: 300px;
  height: 100%;
  left: 0px;
  top: 0px;

  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  border-radius: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 0 : 4)}px;
  padding: 16px 16px 32px 16px;
  z-index: 1000;
  background: #353a40;

  clip-path: polygon(9% 0, 100% 0, 100% 94.5%, 91% 100%, 0 100%, 0 5.5%);

  &::after {
    content: '';
    position: absolute;
    background-color: rgba(0, 0, 0, 1);
    z-index: -1;
    clip-path: polygon(9% 0, 100% 0, 100% 94.5%, 91% 100%, 0 100%, 0 5.5%);
    top: 1.5px;
    left: 1.5px;
    border-radius: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 0 : 4)}px;
    right: 1.5px;
    bottom: 1.5px;
  }
  @media screen and (max-width: 1000px) {
    position: fixed;
    z-index: 100;
    transition: border-radius 0.9s ease-in-out, background 0.3s ease-in-out,
      top 0.6s ease-in-out,
      min-height 1.2s ease-in-out
        ${({ mobileSwipeOpen }) =>
          mobileSwipeOpen ? ', transform 0.6s ease-in-out' : ''};
    top: ${({ mobileSwipeOpen }) =>
      mobileSwipeOpen ? '0px' : `calc(100dvh - 92px)`};
    transform: translateY(${({ swipeOffset }) => swipeOffset}px);
    left: 0px;
    padding: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 16 : 32)}px;
    border: 1px solid
      ${({ mobileSwipeOpen, theme }) =>
        mobileSwipeOpen
          ? 'transparent'
          : getRgbaValue(theme.colors.brandPrimary, 0.8)};
    min-height: ${({ mobileSwipeOpen }) =>
      mobileSwipeOpen ? '100vh' : '200px'};
    width: 100vw;
    z-index: 100;
    background: ${({ mobileSwipeOpen, theme }) =>
      mobileSwipeOpen
        ? 'transparent'
        : getRgbaValue(theme.colors.brandPrimary, 0.8)};
    @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
      -webkit-backdrop-filter: blur(
        ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 50 : 4)}px
      );
      backdrop-filter: blur(
        ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 50 : 4)}px
      );
    }
  }
`

export const SwapInner = styled(Box)<{ mobileSwipeOpen: boolean }>`
  margin: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? '8px 8px' : '0px')};
  padding: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 32 : 0)}px;
  transition-delay: 0.3s;
  height: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? '100vh' : 'auto')};
  border: 1px solid
    ${({ mobileSwipeOpen, theme }) =>
      !mobileSwipeOpen ? 'transparent' : theme.colors.lowOpacityBorder};
  border-radius: 18px;
`

type DismisButtonProps = {
  mobileSwipeOpen: boolean
  isStaking?: boolean
}

export const DismissButton = styled.button<DismisButtonProps>`
  position: absolute;
  right: ${({ isStaking }) => (isStaking ? 16 : 40)}px;
  top: ${({ isStaking }) => (isStaking ? 20 : 40)}px;
  z-index: 12;
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 1 : 0)};
`

export const DragBar = styled(Box)<{ mobileSwipeOpen: boolean }>`
  width: 100%;
  position: relative;
  min-height: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 32 : 90)}px;
  height: 200px;
  margin-top: -32px;
  z-index: 11;
  opacity: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 0 : 1)};
  ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 'max-height: 32px;' : '')};
  @media screen and (min-width: 1000px) {
    display: none;
  }
`

export const DragBarInner = styled.div<{ isStaking?: boolean }>`
  width: 60px;
  height: 4px;
  background-color: rgba(0, 0, 0, 0.6);
  margin-top: 4px;
  border-radius: 2px;
  ${({ isStaking }) => isStaking && 'position: absolute;top: 24px;'}
`

export const TopWrapper = styled(Box)`
  z-index: 10;
  flex: 0;
  padding: 0 51px;
  padding-top: 140px;
  align-items: flex-end;
  gap: 2rem;
  @media screen and (max-width: 1000px) {
    padding: 0;
    padding-top: 80px;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
    .core-block {
      gap: 0.75rem;
    }
  }
`

export const PriceBox = styled(Box)`
  width: auto;
  height: 30px;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.swapBoxPriceLabelBg};

  border-radius: 4px;
  margin: 16px 0 16px;
  span {
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 12px;
    text-transform: uppercase;
  }
  @media screen and (min-width: 1000px) {
    margin: -8px 0 0;
  }
`

export const DetailButton = styled.button<{ noHover?: boolean }>`
  margin-top: 32px;
  border: 1px solid ${(props) => props.theme.colors.lowOpacityBorder};
  box-sizing: border-box;
  margin-right: 8px;
  padding: 12px 16px;
  border-radius: 40px;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  font-family: Space Grotesk;
  display: flex;
  cursor: ${({ noHover }) =>
    typeof noHover !== 'undefined'
      ? noHover
        ? 'default'
        : 'pointer'
      : 'pointer'};
  @media screen and (max-width: 1000px) {
    width: auto;
  }
`
//

export const PageTogglerContainer = styled(Box)<{ isFixed?: boolean }>`
  width: 100%;
  z-index: 9;
  flex: 0;
  justify-content: center;
  align-items: center;
  margin-top: 8rem;
  border-radius: 8px;
  overflow: hidden;
  backdrop-filter: blur(12px);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);

  @media screen and (max-width: 768px) {
    margin-top: 6rem;
    min-width: calc(100vw - 2rem);
    max-width: calc(100vw - 2rem);
    border-radius: 0;
    justify-content: flex-start;
    border: none;
  }

  ${defaultTransition}
  ${({ isFixed }) =>
    isFixed &&
    css`
      max-width: 1400px;
      position: fixed;
      top: -80px;
      z-index: 10000;
      @media screen and (max-width: 1400px) {
        max-width: -webkit-fill-available;
        margin-right: 4rem;
      }
    `}
`

const JerkPreventor = styled.div<{ isFixed?: boolean }>`
  height: ${({ isFixed }) => (isFixed ? 156 : 0)}px;
`

export function PageToggler({
  children,
  isFixed,
  setIsFixed,
}: {
  children: ReactNode[]
  isFixed: boolean
  setIsFixed: (isFixed: boolean) => void
}) {
  const [pageIndex, setPageIndex] = useState(0)
  const pageToggleRef = useRef<HTMLDivElement>(null)
  const jerkPreventorRef = useRef<HTMLDivElement>(null)
  const { scrollY } = useScrollPosition()

  useEffect(() => {
    if (!pageToggleRef?.current) return
    if (!jerkPreventorRef?.current) return
    const topPosition = (
      isFixed ? jerkPreventorRef : pageToggleRef
    ).current.getBoundingClientRect().top

    if (!isFixed && topPosition < 80) {
      setIsFixed(true)
      return
    }
    if (isFixed && topPosition >= -40) {
      setIsFixed(false)
      return
    }
  }, [scrollY, pageToggleRef, jerkPreventorRef, isFixed, setIsFixed])

  return (
    <>
      <PageTogglerContainer isFixed={isFixed} ref={pageToggleRef}>
        <ArrowSection isLeft setPageIndex={setPageIndex} />
        {children.map((child, index) => (
          <HideMobile
            flex={index === 1 ? 1 : 0}
            shouldHide={
              (index === 0 && pageIndex !== 0) ||
              (index === 2 && pageIndex !== 1)
            }
          >
            {child}
          </HideMobile>
        ))}
        <ArrowSection setPageIndex={setPageIndex} />
      </PageTogglerContainer>
      <JerkPreventor ref={jerkPreventorRef} isFixed={isFixed} />
    </>
  )
}

const HideMobile = styled.div<{ shouldHide?: boolean; flex: number }>`
  flex: 1;
  @media screen and (max-width: 768px) {
    flex: ${({ flex }) => flex};
    display: ${({ shouldHide }) => (shouldHide ? 'none' : 'flex')};
  }
`

function ArrowSection({
  isLeft,
  setPageIndex,
}: {
  isLeft?: boolean
  setPageIndex: (index: number) => void
}) {
  function handleClick() {
    setPageIndex(!isLeft ? 1 : 0)
  }
  return (
    <ArrowHolder isLeft={isLeft}>
      <UnstyledButton onClick={handleClick} />
    </ArrowHolder>
  )
}

export const UnstyledButton = styled.button<{ softerFilter?: boolean }>`
  border: none;
  outline: none;
  background: none;
`

const ArrowHolder = styled(Box)<{ isLeft?: boolean }>`
  max-width: 50px;
  max-height: 50px;
  ${UnstyledButton} {
    width: 50px;
    height: 50px;
  }
  @media screen and (min-width: 768px) {
    display: none;
  }
  background-image: url(${({ isLeft }) => {
    return `'/img/layout/arrow-bg-${isLeft ? 'left' : 'right'}.svg'`
  }});
`

type PageLinkProps = {
  $isActive: boolean
  $isFirst?: boolean
}

export const PageLink = styled(Link)<PageLinkProps>`
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  width: 100%;
  flex: 1;
  position: relative;
  text-align: center;
  letter-spacing: -0.01em;
  color: ${(props) => props.theme.semantics.zap.surface.primary};
  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
  background: ${({ $isActive, theme }) =>
    $isActive
      ? 'rgba(255, 255, 255, 0.10)'
      : getRgbaValue(theme.semantics.zap.surface.primary, 0.7)};
  ${defaultTransition}
  text-align: center;
  font-variant-numeric: ordinal;
  font-size: 20px;
  font-style: normal;
  font-weight: ${({ $isActive }) => ($isActive ? 700 : 300)};
  line-height: normal;
  letter-spacing: -0.8px;

  :hover {
    filter: brightness(0.9);
  }

  ${({ $isFirst }) =>
    !$isFirst &&
    css`
      border-left: 1px solid rgba(255, 255, 255, 0.2);
    `}

  .arrow {
    display: none;
  }

  @media screen and (max-width: 768px) {
    font-size: 14px;
    padding: 8px 12px;
    height: 50px;
    text-align: center;
    width: 100%;
    font-variant-numeric: ordinal;
    font-feature-settings: 'dlig' on, 'ss01' on, 'dnom' on;
    font-family: 'Space Grotesk';
    font-size: 20px;
    font-style: normal;
    font-weight: ${({ $isActive }) => ($isActive ? 700 : 300)};
    line-height: normal;
    letter-spacing: -0.8px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    .arrow {
      display: block;
    }
  }
`

export const TablesWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  width: 100%;
  gap: 32px;
  max-width: 800px;
  margin: auto;
  text-transform: uppercase;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`

export const TableTitle = styled.h4`
  font-variant-numeric: ordinal;
  font-feature-settings: 'dlig' on, 'ss01' on, 'dnom' on;
  font-family: 'Space Grotesk';
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 54px; /* 112.5% */
  letter-spacing: -0.96px;
  text-transform: none;
`

export const TableWrapper = styled.div`
  flex: 1;
  padding: 0 0;
  width: 100%;

  @media screen and (max-width: 1200px) {
    min-width: 100%;
    div {
      min-width: 75%;
    }
  }
`

export const RecordContainer = styled.div`
  flex: 1;
  width: 100%;
  padding: 24px 0;
  p {
    width: 50%;
    font-family: Space Grotesk;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 32px;
  }
  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 0.5px;
    background: rgba(196, 196, 196, 0.25);
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
    padding: 8px 0;
    p {
      width: 100%;
    }
  }
`

export const RecordTitle = styled.p`
  flex: 2;
`

export const TopTitle = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.1em;
  color: black !important;
  opacity: 0.6;
  margin-top: -8px;
  margin-bottom: 4px;
`

export const PeriodTitleSwipe = styled.span`
  font-family: Space Grotesk;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 30px;
  text-transform: uppercase;
  color: #000000;
  /* identical to box height */
`

type MobileHeaderContainerProps = {
  mobileSwipeOpen: boolean
}

export const MobileHeaderContainer = styled(Box)<MobileHeaderContainerProps>`
  display: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 'none' : 'flex')};
  flex-direction: column;
  position: absolute;
  @media screen and (min-width: 1000px) {
    display: none;
  }
`

export const DesktopHeaderContainer = styled(Box)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  min-height: 54px;
  border-top-right-radius: 6px;
  width: calc(100% + 34px);
  margin-left: -17px;
  margin-top: -17px;
  background: ${({ theme }) => getRgbaValue(theme.colors.brandPrimary, 1)};
  @media screen and (max-width: 1000px) {
    display: none;
  }
`

export const SubscribeContainer = styled(Box)`
  margin-top: 8px;
  flex-direction: column;
  gap: 16px;
  button {
    width: 100%;
  }
`

type PoolInputProps = {
  isSmall?: boolean
  hasError?: boolean
}

export const PoolInput = styled.input<PoolInputProps>`
  width: 100%;
  height: 56px;
  padding: 8px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  border-radius: 8px;
  outline: none;
  font-family: Space Grotesk;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  position: relative;
  ::placeholder {
    opacity: ${({ theme: { isDark } }) => (isDark ? 0.3 : 0.8)};
  }
  ${({ isSmall }) =>
    isSmall &&
    css`
      max-width: 160px;
      font-size: 18px;
      @media screen and (max-width: 1000px) {
        max-width: 100%;
      }
    `}

  ${({ hasError, theme }) =>
    hasError &&
    css`
      border: 1px solid ${theme.colors.error};
    `}
`

export const PeriodCaption = styled.span`
  overflow: hidden;
  color: #030c12;
  text-align: center;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
`

export const PeriodTimer = styled.span<{ period: string }>`
  /* identical to box height, or 75% */
  margin-bottom: 4px;
  overflow: hidden;
  color: #030c12;
  text-align: center;
  font-feature-settings: 'ss01' on;
  text-overflow: ellipsis;
  font-family: 'Space Grotesk';
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 16px; /* 133.333% */
  letter-spacing: 3.6px;
  text-transform: uppercase;
`

export const CurrencyLabel = styled.span`
  font-size: 14px;
  opacity: 1;
`

export const ConnectWalletButton = styled.h4`
  cursor: pointer;
  margin: 16px 0 24px;
`

export const BarWrapper = styled(Box)`
  width: 100%;
  margin-top: 16px;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`

export const SwapPct = styled.span`
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  text-align: right;
  letter-spacing: 0.05em;
`

export const MobileColumn = styled(Box)`
  @media screen and (max-width: 1000px) {
    flex-direction: column;
  }
`

export const LoadingContainer = styled(Box)`
  min-height: calc(100vh - 400px);
`
